<template>
  <div>
    <div class="temp-comp" ref="temp-comp">放置区域</div>
  </div>
</template>

<script>
export default {
  name: 'temp-comp',
  mounted() {
    const dom = this.$refs['temp-comp'];
    this.$emit('tempCompMounted', dom);
  },
};
</script>

<style>
.temp-comp {
  width: 100%;
  height: 100px;
  background: #dcf3ff;
  color: #26b5ff;

  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
